/**
 * Created by miguel on 22/2/17.
 */
/// <reference path="../documents/DocumentListCell.ts" />

class InvoiceCell extends DocumentListCell
{
    protected nameLabel:MUILabel = null;
    private nextDocumentLabel:MUILabel = null;

    awakeFromHTML(){
        super.awakeFromHTML();
        this.nameLabel = MUIOutlet(this, "client-name-lbl", "MUILabel");
        // this.nextDocumentLabel = MUIOutlet(this, "next-doc-lbl", "MUILabel");
    }

    set item(item:Invoice){
        this.setItem(item);

        this.nameLabel.text = item.legalEntity.name;

        if (item instanceof PurchaseInvoice) {
            this.referenceLabel.text = item.externalReference;
        }        

        // this.nextDocumentLabel.text = item.nextDocument?.documentNumber;

        if (item.status == 0){
            MUICoreLayerAddStyle(this.documentIDLabel.layer, "alert");
        }
    }

}